<template>
  <div class="form-page-shell" :class="{ 'form-page-shell--wide': wide }">
    <div class="form-page-shell__inner">
      <header v-if="!isEdit" class="form-page-shell__hero">
        <div class="form-page-shell__hero-row">
          <div class="form-page-shell__hero-icon" :class="'form-page-shell__hero-icon--' + theme">
            <i :class="icon" />
          </div>
          <div class="form-page-shell__hero-text">
            <h1 class="form-page-shell__hero-title">{{ title }}</h1>
            <p v-if="subtitle" class="form-page-shell__hero-desc">{{ subtitle }}</p>
          </div>
        </div>
      </header>
      <el-card class="form-page-shell__card" shadow="hover">
        <div v-if="isEdit" slot="header" class="form-page-shell__card-header">
          <span>{{ title }}</span>
        </div>
        <div :class="isEdit ? 'form-page-shell__body form-page-shell__body--edit' : 'form-page-shell__body form-page-shell__body--create'">
          <slot />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPageShell',
  props: {
    isEdit: { type: Boolean, default: false },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-edit-outline' },
    theme: { type: String, default: 'primary' },
    wide: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.form-page-shell {
  min-height: calc(100vh - 120px);
  padding: 24px 28px 36px;
  background: transparent;
  box-sizing: border-box;
}

.form-page-shell__inner {
  max-width: 860px;
  margin: 0 auto;
}

.form-page-shell--wide .form-page-shell__inner {
  max-width: 1180px;
}

.form-page-shell__hero {
  margin-bottom: 18px;
}

.form-page-shell__hero-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.form-page-shell__hero-text {
  text-align: left;
  flex: 1;
}

.form-page-shell__hero-icon {
  width: 48px;
  height: 48px;
  margin: 0;
  flex-shrink: 0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  color: #fff;
}

.form-page-shell__hero-icon--primary {
  background: linear-gradient(145deg, #0ea5e9 0%, #38bdf8 100%);
  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.24);
}

.form-page-shell__hero-icon--success {
  background: linear-gradient(145deg, #22c55e 0%, #4ade80 100%);
  box-shadow: 0 8px 24px rgba(74, 222, 128, 0.24);
}

.form-page-shell__hero-icon--warning {
  background: linear-gradient(145deg, #f59e0b 0%, #fbbf24 100%);
  box-shadow: 0 8px 24px rgba(251, 191, 36, 0.24);
}

.form-page-shell__hero-icon--violet {
  background: linear-gradient(145deg, #8b5cf6 0%, #a78bfa 100%);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.24);
}

.form-page-shell__hero-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: -0.02em;
}

.form-page-shell__hero-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--color-text-sub);
}

.form-page-shell__card {
  border-radius: 14px;
  border: 1px solid var(--color-border);
  overflow: hidden;
  background: var(--color-surface);
  box-shadow: var(--shadow-card);
}

.form-page-shell__card >>> .el-card__header {
  border-bottom: 1px solid var(--color-border-soft);
  padding: 18px 24px;
}

.form-page-shell__card >>> .el-card__body {
  padding: 0;
}

.form-page-shell__card-header {
  font-weight: 600;
  font-size: 15px;
  color: var(--color-text);
}

.form-page-shell__body--create {
  padding: 28px 30px 34px;
}

.form-page-shell__body--edit {
  padding: 24px 26px 30px;
}

@media (max-width: 768px) {
  .form-page-shell {
    padding: 18px 16px 28px;
  }

  .form-page-shell__hero-row {
    flex-direction: column;
    gap: 10px;
  }

  .form-page-shell__hero-text {
    text-align: left;
  }

  .form-page-shell__body--create {
    padding: 22px 18px 24px;
  }

  .form-page-shell__body--edit {
    padding: 18px 16px 22px;
  }

  .form-page-shell__hero-title {
    font-size: 21px;
  }
}
</style>
